import { VoidCallback } from '@deqo/foundation';
import { useCallback, useEffect, useState } from 'react';
import { usePrevious } from 'react-use';

export const useSvgPlayer = (initializer: VoidCallback) => {
    const [elmt, setElmt] = useState(null as any);
    const [player, setPlayer] = useState(null as any);
    useEffect(() => {
        if (!elmt) return;
        initializer();
        elmt.svgatorPlayer.ready(() => setPlayer(elmt.svgatorPlayer));
    }, [elmt]);
    return [player, setElmt];
};

export const useToggledMirrorAnim = (player: any, active: boolean) => {
    const wasActive = usePrevious(active);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!player) return;

        if (ready) {
            if ((active && !wasActive)) {
                player.play();
                player.seek(0);
            }
            else if (!active && wasActive) {
                const to = player.totalTime - player.currentTime;
                player.play();
                player.seekTo(to);
            }
        }
        else {
            if (active) {
                player.seekTo(250);
            }
            setReady(true);
        }

    }, [player, active, wasActive, ready]);

    const onKeyframe = useCallback((f: number) => {
        if (active && f >= 249 && f <= 251) {
            player.pause();
        }
    }, [active, player]);

    useEffect(() => {
        if (!player) return;
        player.on('keyframe', onKeyframe);
        return () => player.off('keyframe', onKeyframe);
    }, [player, onKeyframe]);
};

export const useLoopedAnim = (player: any, active: boolean, from: number, to: number) => {
    const wasActive = usePrevious(active);

    useEffect(() => {
        if (!player) return;
        if ((active && !wasActive) || (active && player.currentTime === 0)) {
            player.play();
            player.seek(0);
        }
    }, [player, active, wasActive]);

    const onKeyframe = useCallback((f: number) => {
        if (f >= to && active) {
            player.seekTo(from);
            player.play();
        }
    }, [player, from, to, active]);

    useEffect(() => {
        if (!player) return;
        player.on('keyframe', onKeyframe);
        return () => player.off('keyframe', onKeyframe);
    }, [player, onKeyframe]);
};
